<fhm-search-page [gridData]="gridData"
                 [showLink]="true"
                 [showColumnSearch]="false"
                 [type]="'customer-instance-venue-manager-search'"
                 [showRefresh]="true"
                 (refresh)="refresh()"
                 [styleColumnFn]="styleColumnFn"
                 [paging]="true"
                 [valueColumnFn]="valueColumnFn"
                 [columns]="['name', 'salesRep', 'createdDate', 'contractSignedDate', 'signedDate', 'requiresAction', 'requiresContractDirectorSign']"
                 [sortableColumns]="['name', 'salesRep', 'createdDate', 'contractSignedDate', 'signedDate', 'requiresContractDirectorSign']"
                 (columnSorted)="columnSorted($event)"
                 (selectRecord)="recordSelected($event)"
                 (linkColumnClicked)="signAsDirector($event)">
    <div class="searchControls">
        <fui-filter-form-context>
            <div class="filter">
                <fui-search-control [(ngModel)]="filterName" class="filter-name"
                                    [label]="'fhm.common.label.search'"
                                    (valueChange)="updateFilter()"
                                    [placeholder]="' '"></fui-search-control>
                <fui-search-control [(ngModel)]="filterSalesRep" class="filter-salesRep"
                                    [label]="'fhm.customer-instance-venue-manager-search.filter.salesRep'"
                                    (valueChange)="updateFilter()"
                                    [placeholder]="' '"></fui-search-control>
<!--                <fui-date-control [label]="'fhm.customer-instance-venue-manager-search.filter.createdFrom'"
                                  (valueChange)="updateFilter()"
                                  [(ngModel)]="filterCreatedDateFrom"></fui-date-control>
                <fui-date-control [label]="'fhm.customer-instance-venue-manager-search.filter.createdTo'"
                                  (valueChange)="updateFilter()"
                                  [(ngModel)]="filterCreatedDateTo"></fui-date-control> -->
                <fhm-venue-require-action-multi-select-control class="filter-requiresAction"
                    (valueChange)="changeRequiresAction($event)"></fhm-venue-require-action-multi-select-control>
            </div>
        </fui-filter-form-context>
    </div>
</fhm-search-page>
